import { combineReducers } from '@reduxjs/toolkit';
import { logoutThunk } from './ducks/auth.duck';
import { clearCfDestination } from './util/cfOrder';
import * as globalReducers from './ducks';
import * as pageReducers from './containers/reducers';

/**
 * Function _createReducer_ combines global reducers (reducers that are used in
 * multiple pages) and reducers that are handling actions happening inside one page container.
 * Since we combineReducers, pageReducers will get page specific key (e.g. SearchPage)
 * which is page specific.
 * Future: this structure could take in asyncReducers, which are changed when you navigate pages.
 */
const appReducer = combineReducers({ ...globalReducers, ...pageReducers });

const createReducer = () => {
  return (state, action) => {
    // Clear state when logout is successful
    const shouldClearState = action.type === logoutThunk.fulfilled.type;
    const appState = shouldClearState ? undefined : state;

    // Clear sessionStorage when logging out.
    if (shouldClearState && typeof window !== 'undefined' && !!window.sessionStorage) {
      window.sessionStorage.clear();
    }
    // Story 3.24 — the post-purchase destination lives in localStorage (it has
    // to survive the new tab a password-reset link opens), which the blanket
    // clear above does not reach. Without this line a second person signing
    // in on the same browser would inherit the first one's order. The helper
    // is window-guarded and try/catch'd, so it is safe here unconditionally.
    if (shouldClearState) {
      clearCfDestination();
    }

    return appReducer(appState, action);
  };
};

export default createReducer;
